<script setup>
import { computed, inject, ref } from 'vue'
import StadiumInfo from './StadiumInfo.vue'
import PlyerJersey from './PlyerJersey.vue'
import { loc } from '@/__core__/localization/localization'
import RemakeHeader from '@/__core__/components/headers/remake-header/RemakeHeader.vue'
import PreviousMeetings from './PreviousMeetings.vue'

defineProps({
  data: Object,
})

const langId = inject('langId', '')
const status = inject('status')
const teamOverviewContainerRef = ref(null)
const teamOverviewContainerWidth = computed(() => teamOverviewContainerRef?.value?.clientWidth || 0)
</script>

<template>
  <div class="szw-flex szw-flex-col" ref="teamOverviewContainerRef">
    <div class="szw-flex szw-flex-col szw-gap-1 szw-pt-2">
      <StadiumInfo :stadiumData="data?.stadiumData" />
      <PlyerJersey :jerseyData="data?.jerseyData" />
    </div>
    <div class="szw-gap-1 szw-px-1 szw-py-2 szw-font-bold szw-text-[10px] szw-leading-[12px] szw-tracking-[4%] szw-uppercase">
      <div v-if="status === 'loading'" class="szw-w-[80px] szw-bg-section-static szw-h-[12px] szw-rounded-1 szw-animate-pulse"></div>
      <span v-if="status === 'success'">{{ loc('sm_next_match', langId) }}</span>
    </div>
    <div class="szw-border szw-border-border szw-border-solid szw-flex szw-flex-col szw-items-center szw-gap-1 szw-p-2">
      <remake-header
        :header-data="data.nextMatchHeader"
        :size="teamOverviewContainerWidth"
        :has-shadow="false"
        :has-padding="false"
      />
      <PreviousMeetings
        :home-wins="data.previousMeetings?.wins"
        :away-wins="data.previousMeetings?.losses"
        :draws="data.previousMeetings?.draws"
        :label="loc('sm_previous_matches', langId)"
      />
      <div class="szw-gap-1 szw-p-1 szw-text-[12px] szw-leading-[14px] szw-tracking-[0%] szw-flex szw-justify-between szw-w-full szw-items-center">

        <template v-if="status === 'loading'">
          <div class="szw-w-[80px] szw-bg-section-static szw-h-[14px] szw-rounded-1 szw-animate-pulse"></div>
          <div class="szw-w-[100px] szw-bg-section-static szw-h-[14px] szw-rounded-1 szw-animate-pulse"></div>
        </template>

        <template v-if="status === 'success'">
          <span class="szw-font-light">{{ loc('sm_stadium', langId) }}</span>
          <span class="szw-font-medium">{{ data.stadiumData?.name }}</span>
        </template>
      </div>
    </div>
  </div>
</template>
